const languageConstants = {
  GET_LANGUAGES_REQUEST: 'GET_LANGUAGES_REQUEST',
  GET_LANGUAGES_SUCCESS: 'GET_LANGUAGES_SUCCESS',
  GET_LANGUAGES_FAILURE: 'GET_LANGUAGES_FAILURE',
};

export default languageConstants;
